module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_right_arrow.d295f.png";